import { render, staticRenderFns } from "./changingRol.vue?vue&type=template&id=c8d4962e&"
import script from "./changingRol.vue?vue&type=script&lang=ts&"
export * from "./changingRol.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports